import { render, staticRenderFns } from "./BannerInterno.vue?vue&type=template&id=3f7f20c1&scoped=true&lang=pug&"
import script from "./BannerInterno.vue?vue&type=script&lang=js&"
export * from "./BannerInterno.vue?vue&type=script&lang=js&"
import style0 from "./BannerInterno.vue?vue&type=style&index=0&id=3f7f20c1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7f20c1",
  null
  
)

export default component.exports